import { managementFeeService } from "@services";
import { maskActions } from "./mask.actions";
import { managementFeeConstants, managementFeeBillConstants } from "@constants";
import { message } from "antd";
import { msgTypes, showModal } from "@utils";
import { constructionActions } from "./construction.action";

export const managementFeeActions = {
  /**
   * 取得建案管理費列表
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return dispatch => {
      dispatch({
        type: managementFeeConstants.GET_ALL_REQUEST
      });

      managementFeeService.getAll(constructionUuid, condition).then(
        ({ statistics, config, items, total }) => {
          dispatch({
            type: managementFeeConstants.GET_ALL_SUCCESS,
            constructionUuid,
            items,
            total,
            statistics,
            config,
            condition
          });
        },
        error => {
          dispatch({
            type: managementFeeConstants.GET_ALL_FAILURE,
            error
          });
        }
      );
    };
  },
  get: (constructionUuid, id, cbSuccess, cb = null) => {
    return dispatch => {
      managementFeeService
        .get(constructionUuid, id)
        .then(
          response => {
            cbSuccess && cbSuccess(response);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          cb && cb();
        });
    };
  },
  getSetting: (constructionUuid, cbSuccess) => {
    return dispatch => {
      managementFeeService.getSetting(constructionUuid).then(
        response => {
          cbSuccess && cbSuccess(response);
        },
        error => {
          showModal(msgTypes.ERROR, "錯誤", error);
        }
      );
    };
  },
  gerPeriodList: (constructionUuid, cbSuccess) => {
    return dispatch => {
      managementFeeService.gerPeriodList(constructionUuid).then(
        response => {
          cbSuccess && cbSuccess(response);
        },
        error => {
          showModal(msgTypes.ERROR, "錯誤", error);
        }
      );
    };
  },
  resetAll: () => ({
    type: managementFeeConstants.RESET_ALL_SUCCESS
  }),
  publish: (constructionUuid, id, info) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .publish(constructionUuid, id, info)
        .then(
          response => {
            message.success(response);
            managementFeeActions.__getAll(dispatch, getState);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  notifyUnpaidPeriodBills: (constructionUuid, periodId) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .notifyUnpaidPeriodBills(constructionUuid, periodId)
        .then(
          response => {
            message.success(response);
            managementFeeActions.__getAllBills(dispatch, getState);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  notifyUnpaidBill: (constructionUuid, periodId, id, cbSuccess = null) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .notifyUnpaidBill(constructionUuid, periodId, id)
        .then(
          response => {
            message.success(response);
            cbSuccess && cbSuccess();
            managementFeeActions.__getAllBills(dispatch, getState);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  getAllBills: (constructionUuid, condition) => {
    return dispatch => {
      dispatch({
        type: managementFeeBillConstants.GET_ALL_REQUEST
      });
      managementFeeService.getAllBills(constructionUuid, { ...condition }).then(
        ({ items, statistics, config, community_bank_account, total }) => {
          dispatch({
            type: managementFeeBillConstants.GET_ALL_SUCCESS,
            constructionUuid,
            statistics,
            config,
            community_bank_account,
            items,
            total,
            condition
          });
        },
        error => {
          dispatch({
            type: managementFeeBillConstants.GET_ALL_FAILURE,
            error
          });
        }
      );
    };
  },
  resetAllBills: () => ({
    type: managementFeeBillConstants.RESET_ALL_SUCCESS
  }),
  create: (constructionUuid, info, cbSuccess, cb = null) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      dispatch({
        type: managementFeeConstants.EDIT_MANAGEMENT_FEE_REQUEST
      });
      managementFeeService
        .create(constructionUuid, info)
        .then(
          response => {
            dispatch({
              type: managementFeeConstants.EDIT_MANAGEMENT_FEE_SUCCESS
            });
            cbSuccess && cbSuccess();
            message.success(response);
            managementFeeActions.__getAll(dispatch, getState);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
            dispatch({
              type: managementFeeConstants.EDIT_MANAGEMENT_FEE_FAILURE,
              error
            });
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
          cb && cb();
        });
    };
  },
  update: (constructionUuid, id, info, cbSuccess, cb = null) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      dispatch({
        type: managementFeeConstants.EDIT_MANAGEMENT_FEE_REQUEST
      });
      managementFeeService
        .update(constructionUuid, id, info)
        .then(
          response => {
            dispatch({
              type: managementFeeConstants.EDIT_MANAGEMENT_FEE_SUCCESS
            });
            cbSuccess && cbSuccess();
            message.success(response);
            managementFeeActions.__getAll(dispatch, getState);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
            dispatch({
              type: managementFeeConstants.EDIT_MANAGEMENT_FEE_FAILURE,
              error
            });
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
          cb && cb();
        });
    };
  },
  resetUpdate: () => ({
    type: managementFeeConstants.RESET_EDIT_MANAGEMENT_FEE_SUCCESS
  }),
  delete: (constructionUuid, id) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .delete(constructionUuid, id)
        .then(
          response => {
            message.success(response);
            managementFeeActions.__getAll(dispatch, getState);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  updateBillPrintSetting: (constructionUuid, info, onSuccess, cb = null) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .updateBillPrintSetting(constructionUuid, info)
        .then(
          response => {
            message.success(response);
            dispatch(constructionActions.getHouseholdMeta(constructionUuid, false));
            onSuccess && onSuccess();
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          cb && cb();
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  createBillPaymentHistory: (constructionUuid, periodId, billId, info, cbSuccess, cb = null) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .createBillPaymentHistory(constructionUuid, periodId, billId, info)
        .then(
          response => {
            cbSuccess && cbSuccess();
            message.success(response);
            managementFeeActions.__getAllBills(dispatch, getState);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          cb && cb();
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  updateBillPaymentHistory: (
    constructionUuid,
    periodId,
    billId,
    paymentHistoryId,
    info,
    cbSuccess,
    cb = null
  ) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .updateBillPaymentHistory(constructionUuid, periodId, billId, paymentHistoryId, info)
        .then(
          response => {
            cbSuccess && cbSuccess();
            message.success(response);
            managementFeeActions.__getAllBills(dispatch, getState);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          cb && cb();
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  deleteBillPaymentHistory: (constructionUuid, periodId, billId, paymentHistoryId) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .deleteBillPaymentHistory(constructionUuid, periodId, billId, paymentHistoryId)
        .then(
          response => {
            message.success(response);
            managementFeeActions.__getAllBills(dispatch, getState);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  previewBill(constructionUuid, periodId, info, cbSuccess = null) {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .previewBill(constructionUuid, periodId, info)
        .then(
          response => {
            cbSuccess && cbSuccess(response);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  exportBill(constructionUuid, periodId, info, cbSuccess = null, cb = null) {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .exportBill(constructionUuid, periodId, info)
        .then(
          response => {
            message.success("匯出繳費單成功");
            cbSuccess && cbSuccess();
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          cb && cb();
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  exportPayment(constructionUuid, fileName, info, cbSuccess = null, cb = null) {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));
      managementFeeService
        .exportPayment(constructionUuid, fileName, info)
        .then(
          () => {
            message.success("匯出繳費明細成功");
            cbSuccess && cbSuccess();
          },
          error => {
            message.error(`匯出繳費明細失敗：${error}`);
          }
        )
        .finally(() => {
          cb && cb();
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  __getAll: (dispatch, getState) => {
    const { managementFees } = getState();
    dispatch(
      managementFeeActions.getAll(
        managementFees?.query?.constructionUuid,
        managementFees?.query?.condition
      )
    );
  },
  __getAllBills: (dispatch, getState) => {
    const { managementFeeBills } = getState();
    dispatch(
      managementFeeActions.getAllBills(
        managementFeeBills?.query?.constructionUuid,
        managementFeeBills?.query?.condition
      )
    );
  }
};
